import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  role?: "superadmin" | "admin";
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  role,
}) => {
  const { isAuthenticated, isInitializing, adminUser } = useAuth();
  const currentRole = adminUser?.role ?? null;

  if (isInitializing) {
    return null;
  }
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  if (role && currentRole !== role) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};
